import { DatePipe } from '@angular/common';
import { RestedResult } from 'server/shared/helpers/eligibilityChecks';
import { dateFnsDayDateHHmmToken } from 'server/shared/helpers/removeTimeZoneOffset';
import { TranslationKeyTranslation } from 'server/shared/models/translation';
import { PoolerUser } from 'server/shared/models/user';

export function getUserHasBlacklistedDepartment(
  departmentId: string,
  user: PoolerUser,
): { hasBlacklistedJobDepartment: boolean } {
  return {
    hasBlacklistedJobDepartment:
      user.userPreferenceDepartmentBlacklist?.some(
        (id) => id === departmentId,
      ) || false,
  };
}

export function getRestWarningString(
  restStatus: RestedResult,
  i18n: TranslationKeyTranslation,
  datePipe: DatePipe,
): string {
  if (!restStatus.hasRested) {
    let restWarning =
      (i18n.restWarningLong as string) ||
      'Die Ruhezeit von 11 Stunden ist nicht gewährleistet. Bitte überprüfen Sie die Ruhezeit.';

    if (restStatus.startsWorkingAt) {
      restWarning += '\n';
      restWarning +=
        ((i18n.nextShiftStart as string) || 'Nächste Schicht beginnt am: ') +
        datePipe.transform(
          restStatus.startsWorkingAt,
          dateFnsDayDateHHmmToken,
        ) +
        ' ';
    }
    if (restStatus.workedUntil) {
      restWarning += '\n';
      restWarning +=
        ((i18n.lastShiftEnd as string) || 'Letzte Schicht endet am: ') +
        datePipe.transform(restStatus.workedUntil, dateFnsDayDateHHmmToken) +
        ' ';
    }
    return restWarning;
  } else {
    return '';
  }
}
